import { __rest } from "tslib";
import * as React from 'react';
const SelectLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", fill: "currentColor", width: size || "32", height: size || "32" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M16.5,6 C22.29,6 27,10.71 27,16.5 C27,22.29 22.29,27 16.5,27 C10.71,27 6,22.29 6,16.5 C6,10.71 10.71,6 16.5,6 Z M16.5,7 C11.262,7 7,11.262 7,16.5 C7,21.738 11.262,26 16.5,26 C21.738,26 26,21.738 26,16.5 C26,11.262 21.738,7 16.5,7 Z M20.2241,13.4287 L20.9311,14.1357 L15.1411,19.9247 L12.0691,16.8537 L12.7761,16.1467 L15.1411,18.5107 L20.2241,13.4287 Z" })));
};
SelectLarge.displayName = 'SelectLarge';
export default SelectLarge;
//# sourceMappingURL=SelectLarge.js.map